import React, { useState, useEffect } from 'react';

const GlobalPromptModal = ({ isOpen, onClose, globalPrompt, onSave }) => {
  const [prompt, setPrompt] = useState('');

  useEffect(() => {
    try {
      setPrompt(globalPrompt || '');
    } catch (error) {
      console.error('Error setting prompt:', error);
      setPrompt('');
    }
  }, [globalPrompt]);

  if (!isOpen) return null;

  const handleSave = () => {
    try {
      onSave(prompt);
      onClose();
    } catch (error) {
      console.error('Error saving prompt:', error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-[800px] max-h-[80vh] flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Global Prompt</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ×
          </button>
        </div>
        
        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-2">
            This prompt will be applied to all nodes in the conversation. Use it to set overall behavior and guidelines.
          </p>
        </div>

        <textarea
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          className="flex-1 w-full p-4 border rounded-md text-sm min-h-[300px] mb-4"
          placeholder="Enter global prompt instructions..."
        />

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 border rounded hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlobalPromptModal; 